import CustomizePage from "./CustomizePage";

export default CustomizePage;
